export const MODES = {
  CREATE: 'CREATE',
  EDIT: 'EDIT',
};
